import { useState, useEffect, useCallback, useRef } from 'react'
import { useParams, useNavigate, useLocation, Link } from "react-router-dom"
// ------ Services ------ //
import * as leadCaptureService from '../../../services/leadCaptureService'
import * as clientEventService from '../../../services/clientEventService'
// ------ Styles ------ //
import styles from "./ExhibitorList.module.css"
// ------ Components ------ //
import LCExhibitor from "../../../components/LeadCapture/ExhibitorList/LCExhibitor"
import SearchBar from "../../../components/Miscellaneous/SearchBar"
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareCaretUp, faSquareCaretDown } from '@fortawesome/free-solid-svg-icons'
// ------ Image Elements ------ //
const up = <FontAwesomeIcon icon={faSquareCaretUp} style={{ color: 'blue', width: '20px', height: '20px' }} />
const down = <FontAwesomeIcon icon={faSquareCaretDown} style={{ color: 'blue', width: '20px', height: '20px' }} />

const ExhibitorList = ({ user }) => {
    const [exhibitors, setExhibitors] = useState([])
    const [exhibitorNameFilter, setExhibitorNameFilter] = useState("")
    const [exhibitorOrganizationFilter, setExhibitorOrganizationFilter] = useState("")
    const [combinedFilteredExhibitors, setCombinedFilteredExhibitors] = useState([])
    const [isCleared, setIsCleared] = useState(false)
    const [loaded, setLoaded] = useState(false)
    const [message, setMessage] = useState([''])
    const [sorting, setSorting] = useState({ key: "refNumber", ascending: true });
    const navigate = useNavigate()
    const location = useLocation()
    const passedState = location.state
    // useLocation & useNavigate --- Client state from previous page
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
                leadCaptureId: passedState.leadCaptureId,
                leadCaptureName: passedState.leadCaptureName,
            }
            clientEventInfoRef.current = passedData
        }

    }
    useEffect(() => {
        const interval = setInterval(() => checkClientEvent(), (300)) // run events fetch every .3 seconds
        return () => clearInterval(interval)
    }, [])
    const checkClientEvent = () => {
        // Update clientevent with every render when its value has changed.
        let savedClientEvent = clientEventService.getClientEvent()
        if (clientEventInfoRef.current && clientEventInfoRef.current.leadCaptureId !== undefined &&
            savedClientEvent && savedClientEvent.leadCaptureId !== undefined &&
            savedClientEvent.leadCaptureId !== clientEventInfoRef.current.leadCaptureId) {
            setClientEventInfo(savedClientEvent)
            clientEventInfoRef.current = savedClientEvent;
        }
    }
    // ------ Name Search ------ //
    const NameFilter = filterString => {
        if (filterString && filterString.toLowerCase) {
            filterString = filterString.toLowerCase()
        }
        let filtered = []
        exhibitors.forEach((exhibitor) => {
            const nameFirst = exhibitor.firstName.toLowerCase()
            const nameLast = exhibitor.lastName.toLowerCase()
            if (!filterString || nameFirst.includes(filterString) || nameLast.includes(filterString)) {
                filtered.push(exhibitor)
            }
        })
        return filtered
    }
    const filteredByName = exhibitors && exhibitors.length ? NameFilter(exhibitorNameFilter) : []
    // ------ Organization Search ------ //
    const OrganizationFilter = filterString => {
        if (filterString && filterString.toLowerCase) {
            filterString = filterString.toLowerCase()
        }
        let filtered = []
        exhibitors.forEach((exhibitor) => {
            const organization = exhibitor.organization.toLowerCase()
            if (!filterString || organization.includes(filterString)) {
                filtered.push(exhibitor)
            }
        })
        return filtered
    }

    const filteredByOrganization = exhibitors && exhibitors.length ? OrganizationFilter(exhibitorOrganizationFilter) : []
    // ------ Helper Functions ------ //
    const clearFilters = () => {
        setIsCleared(true)
        setExhibitorNameFilter("")
        setExhibitorOrganizationFilter("")
        setIsCleared(false)
    }
    function applySorting(key) {
        if (sorting.key === key) {
            setSorting({ ...sorting, ascending: !sorting.ascending });
        } else {
            setSorting({ key: key, ascending: true });
        }
    }
    const fetchExhibitors = async () => {
        const exhibitors = await leadCaptureService.getExhibitorsForEvent(clientEventInfo.leadCaptureId);
        if (exhibitors && exhibitors.length > 0) {
            setExhibitors(exhibitors);
        }
        else {
            setExhibitors([]);
        }
        clearFilters();
        setLoaded(true);
    }
    useEffect(() => {
        if (exhibitors && exhibitors.length > 0) {
            let exhs = [...exhibitors];
            let filteredResults = []
            // apply filtering
            exhs.forEach((exh) => {
                if (filteredByName.includes(exh)) {
                    if (filteredByOrganization.includes(exh)) {
                        filteredResults.push(exh)
                    }
                }
            })
            // apply sorting
            let sortedResults = filteredResults.sort((a, b) => {
                const optionA = a[sorting.key] && a[sorting.key] !== undefined ? a[sorting.key].toString().toLowerCase() : ''

                const optionB = b[sorting.key] && b[sorting.key] !== undefined ? b[sorting.key].toString().toLowerCase() : ''

                if (optionA < optionB) {
                    return sorting.ascending ? -1 : 1;
                }
                if (optionA > optionB) {
                    return sorting.ascending ? 1 : -1;
                }
                return 0;
            })
            setCombinedFilteredExhibitors(sortedResults);
        }

    }, [exhibitors, exhibitorNameFilter, exhibitorOrganizationFilter, sorting])
    useEffect(() => {
        if (clientEventInfo && clientEventInfo.leadCaptureId) {
            fetchExhibitors();
        }
        else if (clientEventInfo && clientEventInfo.leadCaptureId === undefined) {
            setLoaded(true);
        }
        else {
            //setLoaded(true);
        }
    }, [clientEventInfo, clientEventInfo.leadCaptureId])
    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
            else {
                setLoaded(true);
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
                leadCaptureId: passedState.leadCaptureId,
                leadCaptureName: passedState.leadCaptureName,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }
    }, [])
    return (
        <div className="page-area">
            <h1>Exhibitors</h1>
            {loaded ?
                <>
                    {
                        clientEventInfo && clientEventInfo.leadCaptureId ?
                            <Link to={`/ExhibitorConfig`} state={clientEventInfoRef} className={styles.eventLinks} key={clientEventInfo.leadCaptureId} title="Create new exhibitor.">
                                <h3>Create New Exhibitor</h3>
                            </Link> :
                            <div className={styles.errorExhibitorsMessage}> No Lead Capture selected.</div>
                    }
                    <br />
                    <div className={styles.containerExhibitors}>
                        <SearchBar
                            searchName={exhibitorNameFilter}
                            handleSearchName={setExhibitorNameFilter}
                            placeholder="Exhibitor First/Last Name"
                            label="Name"
                            isCleared={isCleared === true || isCleared === false ? isCleared : false}
                        />
                        <SearchBar
                            searchName={exhibitorOrganizationFilter}
                            handleSearchName={setExhibitorOrganizationFilter}
                            placeholder="Organization"
                            label="Organization"
                            isCleared={isCleared === true || isCleared === false ? isCleared : false}
                        />

                        {exhibitorNameFilter || exhibitorOrganizationFilter ?
                            <button onClick={clearFilters} id={styles.clearFilters}>
                                Clear
                            </button>
                            :
                            <>
                            </>
                        }
                        {combinedFilteredExhibitors && combinedFilteredExhibitors.length ?
                            <div className={styles.tableExhibitorsContainer}>
                                <table className={styles.tableExhibitors}>
                                    <thead>
                                        <tr className={styles.trExhibitors}>

                                            <th className={styles.thExhibitors} onClick={() => applySorting('refNumber')}>
                                                Reference Number {sorting.key === 'refNumber' && sorting.ascending ? up : down}
                                                <HoverButton
                                                    title={'Reference number for direct navigation.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thExhibitors} onClick={() => applySorting('firstName')}>
                                                First Name {sorting.key === 'firstName' && sorting.ascending ? up : down}
                                                <HoverButton
                                                    title={'Exhibitor first name.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thExhibitors} onClick={() => applySorting('lastName')}>
                                                Last Name {sorting.key === 'lastName' && sorting.ascending ? up : down}
                                                <HoverButton
                                                    title={'Exhibitor last name.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thExhibitors} onClick={() => applySorting('passcode')}>
                                                Passcode {sorting.key === 'passcode' && sorting.ascending ? up : down}
                                                <HoverButton
                                                    title={'Passcode.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thExhibitors} onClick={() => applySorting('organization')}>
                                                Organization {sorting.key === 'organization' && sorting.ascending ? up : down}
                                                <HoverButton
                                                    title={'Exhibitor organization.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thExhibitors} onClick={() => applySorting('email')}>
                                                Email {sorting.key === 'email' && sorting.ascending ? up : down}
                                                <HoverButton
                                                    title={'Exhibitor email.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thExhibitors}></th>
                                        </tr>
                                    </thead>
                                    <tbody key={combinedFilteredExhibitors.length}>
                                        {combinedFilteredExhibitors.map((item, index) => (
                                            <LCExhibitor
                                                exhibitorItem={item}
                                                key={index}
                                            ></LCExhibitor>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div>
                                {clientEventInfo && clientEventInfo.leadCaptureId ?
                                    exhibitors && exhibitors.length > 0 ? 
                                        <div className={styles.errorExhibitorsMessage}> No exhibitors match filter.</div>
                                    :
                                    <div className={styles.errorExhibitorsMessage}> No exhibitors configured for Lead Capture!</div>
                                    : <div className={styles.errorExhibitorsMessage}> Select Lead Capture!</div>
                                }
                            </div>
                        }
                    </div>
                    <br /> <br />
                    <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                </>
                :
                <LoadingSpinner />
            }
        </div>
    );
}

export default ExhibitorList;